//Keys
export const Types = {
  SETPAGE: '@setPage',
  SETQUERY: '@setQuery',
  SETDETAIL: '@setDetail'
}

//Reducer
const INITIAL_STATE = {
  page: {},
  query: {
    numero: '',
    tipoOperacao: '',
    dataInicial: '',
    dataFinal: '',
    pagina: ''
  },
  detail: {}
}

export default function reducer(state: any = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case Types.SETPAGE:
      return { ...state, page: payload }
    case Types.SETQUERY:
      return {
        ...state,
        query: {
          tipoOperacao: payload.tipoOperacao,
          numero: payload.numero,
          dataInicial: payload.dataInicial,
          dataFinal: payload.dataFinal,
          pagina: payload.pagina
        }
      }
    case Types.SETDETAIL:
      return { ...state, detail: payload }

    default:
      return state
  }
}

//Actions
export const setPage = (payload: any) => {
  return { type: Types.SETPAGE, payload: payload }
}

export const setQuery = (payload: any) => {
  return { type: Types.SETQUERY, payload: payload }
}

export const setDetail = (payload: any) => {
  return { type: Types.SETDETAIL, payload: payload }
}
